(function () {
  function activate(facade) {
    var id = facade.dataset.videoId;
    if (!id) return;
    var iframe = document.createElement('iframe');
    iframe.className = 'yt-facade__iframe';
    iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
    iframe.title = facade.getAttribute('aria-label') || 'YouTube video player';
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    facade.replaceWith(iframe);
  }

  document.addEventListener('click', function (event) {
    var facade = event.target.closest('.yt-facade');
    if (facade) activate(facade);
  });
})();
